module.exports = __webpack_public_path__ + "static/media/AK-logo1.5f913855.png";